module.exports = {
    api_url: process.env.VUE_APP_API_URL
}